import { render, staticRenderFns } from "./proposal-header.vue?vue&type=template&id=3212a748"
import script from "./proposal-header.vue?vue&type=script&lang=js"
export * from "./proposal-header.vue?vue&type=script&lang=js"
import style0 from "./proposal-header.vue?vue&type=style&index=0&id=3212a748&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports